import { render, staticRenderFns } from "./before_pos.vue?vue&type=template&id=9774a950&scoped=true&"
import script from "./before_pos.vue?vue&type=script&lang=js&"
export * from "./before_pos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9774a950",
  null
  
)

export default component.exports